/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber24Small = createReactComponent("outline", "number-24-small", "IconNumber24Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-2" }]]);

export { IconNumber24Small as default };
//# sourceMappingURL=IconNumber24Small.mjs.map
